import type { User } from "./User";

export type OAuthNativeResultDetail =
  | { status: "success"; user?: User }
  | { status: "error"; message: string; code?: string; details?: string };

export const oauthNativeResult = {
  eventName: "bhadapms:oauth-native-result",
  
  dispatch(detail: OAuthNativeResultDetail): void {
    window.dispatchEvent(new CustomEvent(this.eventName, { detail }));
  },
  
  subscribe(cb: (detail: OAuthNativeResultDetail) => void): () => void {
    const handler = (event: Event) => {
      const customEvent = event as CustomEvent<OAuthNativeResultDetail>;
      cb(customEvent.detail);
    };
    window.addEventListener(this.eventName, handler);
    
    return () => {
      window.removeEventListener(this.eventName, handler);
    };
  },
};